<template>
    <v-card v-bind="props_card">
        <v-card-text :class="{ 'px-12 py-8': detect == 'pc' }">
            <v-row justify="space-between" align="center">
                <v-col cols="12" lg="">
                    <div class="tit tit--xs">
                        <v-layout
                            v-bind="{
                                'align-center': true,
                                'justify-space-between': detect == 'mobile',
                            }"
                            style="gap:16px"
                        >
                            <span>
                                <b class="primary--text">{{ user?.name }}</b>
                                <span>님 반갑습니다</span>
                            </span>
                        </v-layout>
                    </div>
                </v-col>
                <v-col cols="12" lg="auto">
                    <v-layout
                        v-bind="{
                            'align-center': true,
                            'justify-end': detect == 'pc',
                            'justify-space-between': detect == 'mobile',
                        }"
                    >
                        <span> 보증금 </span>
                        <v-btn text min-width="auto" class="cash-btn mr-n3" :class="{ 'my-n1': detect == 'pc' }" to="/mypage/cashes/inquiry">
                            <v-layout justify-end>
                                <b class="primary--text"> {{ (user?.deposit || 0)?.format?.() }} </b>
                                <span>원</span>
                            </v-layout>
                        </v-btn>
                    </v-layout>
                </v-col>
            </v-row>
            <kcb-cert ref="kcbCert" />
        </v-card-text>
    </v-card>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";
import { mapActions, mapState } from "vuex";

import KcbCert from "@/components/plugins/kcb/kcb-cert.vue";

export default {
    components: {
        KcbCert,
    },
    data: () => ({
        detect,
    }),
    computed: {
        ...mapState(["user"]),
        props_card() {
            switch (detect) {
                case "pc": {
                    return {
                        rounded: true,
                    };
                }
                case "mobile": {
                    return {
                        rounded: false,
                        elevation: 0,
                    };
                }
            }
        },
    },
    mounted() {
        this.getUser();
    },
    methods: {
        ...mapActions(["getUser"]),
    },
};
</script>

<style lang="scss" scoped>
.cash-btn::before {
    display: none;
}
</style>
